export default {"src":"/_next/static/media/facebook.02d31f47.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};